import { getDebuggerRule } from './getShouldLog';
import { EVENT_PREFIX } from './constants';
import { log } from './log';
import { getInternalConfig } from './index';
const isTopLevel = (win = window) => (win.top === win.self || !!win.Cypress) && !win.frameElement;
/**
 * Gets debugger window object from window.sznIVA.debugger, or returns undefined if it doesn't exist.
 * @returns
 */
const getGlobalDebuggerObject = () => { var _a; return (_a = window.sznIVA) === null || _a === void 0 ? void 0 : _a.debugger; };
/**
 * Creates or updates debugger window object in window.sznIVA.debugger.
 * @param windowObject Object with properties to update.
 */
const upsertGlobalDebuggerObject = (windowObject) => {
    window.sznIVA = window.sznIVA || {};
    window.sznIVA.debugger = Object.assign(Object.assign({}, window.sznIVA.debugger), windowObject);
};
/**
 * Returns top frame debugger rule saved in the window object.
 */
const getTopFrameRule = () => { var _a; return (_a = getGlobalDebuggerObject()) === null || _a === void 0 ? void 0 : _a.topFrameRule; };
/**
 * Handles message event from iframes requesting debugger rule.
 */
const handlerFromChildMessage = (event) => {
    var _a;
    if (event.source && event.data.type === `${EVENT_PREFIX}request_debug_settings`) {
        const rule = getDebuggerRule();
        event.source.postMessage({
            type: `${EVENT_PREFIX}debug_settings`,
            rule,
        }, '*');
        if (!((_a = getGlobalDebuggerObject()) === null || _a === void 0 ? void 0 : _a.iframeBridgeNotified)) {
            if (rule) {
                log(getInternalConfig(), undefined, undefined, `Top frame sends a debugger rule "${rule}" to iframes.`);
            }
            upsertGlobalDebuggerObject({ iframeBridgeNotified: true });
        }
    }
};
/**
 * Handles message event from top window containing debugger rule.
 */
const handlerFromTopMessage = (event) => {
    if (event.data.type === `${EVENT_PREFIX}debug_settings`) {
        upsertGlobalDebuggerObject({ topFrameRule: event.data.rule });
    }
};
/**
 * Init mechanism of getting current debugging rule from top window.
 */
const initIframeBridge = () => {
    if (isTopLevel()) {
        window.addEventListener('message', (event) => handlerFromChildMessage(event));
    }
    else {
        window.addEventListener('message', (event) => handlerFromTopMessage(event));
        window.top.postMessage({ type: `${EVENT_PREFIX}request_debug_settings` }, document.referrer || '*');
    }
};
export { getInternalConfig, getTopFrameRule, getGlobalDebuggerObject, initIframeBridge, isTopLevel, upsertGlobalDebuggerObject, };
